module.exports = __webpack_public_path__ + "img/zhAward-c.eeddf609.png";